import Repository from "../Repository";

const resource = "/bo/operations";
export default {
  /**
   * Get all operations dropdowns
   */
  getDropdowns() {
    return Repository.get("/bo/parameter/operations");
  },

  /**
   * Get all operations
   */
  get() {
    return Repository.get(`${resource}`);
  },

  /**
   * Create an operation
   */
  create(payload) {
    return Repository.post(`${resource}`, payload);
  },

  /**
   * Get an operation
   */
  getOperation(operationId) {
    return Repository.get(`${resource}/${operationId}`);
  },

  /**
   * Update an operation
   */
  updateOperation(operationId, payload) {
    return Repository.put(`${resource}/${operationId}`, payload);
  },

  /**
   * Delete an operation
   */
  deleteOperation(operationId) {
    return Repository.delete(`${resource}/${operationId}`);
  }
};
